import { MyOrganizationsQuery } from '@/graphql/graphql';
import { atom } from 'jotai';

export const ORGANIZATIONS_KEY = '@organizations';

const value = localStorage.getItem(ORGANIZATIONS_KEY);
const organizations: MyOrganizationsQuery['organizations'] = value ? JSON.parse(value) : [];
export const organizationsAtom = atom(organizations);
